/** @jsx jsx */
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';
import { jsx } from '@emotion/core';
import { Grid } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';
import { STEPS } from '../constants';
import Layout from '../StepLayout';
import FilePicker from './FilePicker';
import Status from './Status';

export const DeclarationFormProofStep = (): JSX.Element => {
  const { t } = useTranslation();
  const [field, meta, helpers] = useField(STEPS.file);

  const isAFileUploaded = !!field.value;

  // Formik's helpers are recreated at each Formik's context update. see (https://github.com/jaredpalmer/formik/issues/2268)
  const setFile = useCallback((file: File): void => {
    helpers.setTouched(true);
    helpers.setValue(file);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout title={t('challenges.declaration.proof.title')} step={STEPS.file}>
      <Grid
        container
        justify="center"
        alignItems="center"
        wrap="nowrap"
        css={(theme: ICustomTheme) => ({
          [theme.breakpoints.down('sm')]: {
            flexDirection: 'column-reverse',
          },
        })}
      >
        <Grid item>
          <FilePicker
            isAFileUploaded={isAFileUploaded}
            file={field.value}
            setFile={setFile}
          />
        </Grid>
        <Grid item>
          <Status
            isAFileUploaded={isAFileUploaded}
            fileName={field.value?.name}
            error={meta.touched && meta.error ? meta.error : undefined}
          />
        </Grid>
      </Grid>
    </Layout>
  );
};
